import React from 'react'
const FlexWrapper = ({ children, className }) => {
	return <div className={`flex justify-between flex-wrap gap-2.5 ${className}`}>{children}</div>
}

export default FlexWrapper
